var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTogo24New(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.6667H39.6667M39.6667 18.6667H42.5511C43.6034 18.6667 44.5254 19.371 44.8023 20.3861L50.5295 41.3861C50.9343 42.8705 49.817 44.3334 48.2784 44.3334H32.6667M39.6667 18.6667L32.6667 44.3334M32.6667 44.3334H10.0934C8.54315 44.3334 7.42394 42.8496 7.84981 41.3591L11.6667 28.0001",
    strokeWidth: 4.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.6667H13.2837C12.311 18.6667 11.4404 19.2701 11.0989 20.1808L9.3489 24.8475C8.77687 26.3729 9.90453 28.0001 11.5337 28.0001H36.1667",
    strokeWidth: 4.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6666 4.66675C35 7.00008 30.3333 9.33342 32.6666 11.6667",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0069 4.66675C26.3403 7.00008 21.6736 9.33342 24.0069 11.6667",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTogo24New);
export default __webpack_public_path__ + "static/media/ico-togo-24-new.7ab0a2bb.svg";
export { ForwardRef as ReactComponent };